<template>
  <WizardStep id="review" label="Übersicht" next-label="Anfrage abschicken">
    
<FormKitLazyProvider config-file="true">
<div>
      <h3 class="typo-h2">Terminvereinbarung abschliessen</h3>
      <p class="typo-lead-2 text-gray-500">
        Bitte überprüfen Sie Ihre Angaben und klicken Sie anschliessend auf
        "Anfrage abschicken".
      </p>

      <p class="mt-32">
        Wir bearbeiten Ihre Anfrage innerhalb der nächsten Werktage.
      </p>

      <table
        v-if="data.personal && data.contact"
        class="w-full text-left align-top order-summary-table lg:text-lg mt-32"
      >
        <tbody>
          <tr>
            <th>Produkt</th>
            <td v-html="$sup(product)" />
          </tr>
          <tr>
            <th>Filiale</th>
            <td>
              {{ agency }}
            </td>
          </tr>
          <tr>
            <th>Datum</th>
            <td>{{ date }}, {{ time }}</td>
          </tr>
          <tr>
            <th>Persönliche Angaben</th>
            <td>
              <div>{{ data?.personal?.company }}</div>
              <div v-if="data.personal.isCustomer">
                {{
                  $texts(
                    'wizard.isAlreadyCustomer',
                    'Ich bin bereits Kundin oder Kunde der Schaffhauser Kantonalbank',
                  )
                }}
              </div>
              <div>
                {{ data.personal.salutation === 'm' ? 'Herr' : 'Frau' }}
              </div>
              <div>
                {{ data.personal.firstName }} {{ data.personal.lastName }}
              </div>
              <div v-if="birthdate">
                {{ birthdate }}
              </div>
            </td>
          </tr>
          <tr>
            <th>Kontaktangaben</th>
            <td>
              <div>{{ data.contact.addressLine1 }}</div>
              <div>
                {{ data.contact.postalCode }} {{ data.contact.locality }}
              </div>
              <div>{{ data.contact.email }}</div>
              <div>{{ data.contact.phone }}</div>
              <div>{{ meansOfContact }}</div>
              <div v-if="data.contact.contact.customerAvailability">
                <div>{{ data.contact.contact.customerAvailability }}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <FormKit
        id="message"
        type="textarea"
        name="message"
        label="Bemerkungen"
        outer-class="mt-24"
      />

      <FormTerms />
    </div>
</FormKitLazyProvider>

  </WizardStep>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormKitOptionsItem } from '@formkit/inputs'
import { formatDate } from '~/helpers/date'

const props = defineProps<{
  product?: string
  data: any
  agencies: FormKitOptionsItem[]
}>()

const { $sup } = useNuxtApp()
const { $texts } = useEasyTexts()

const birthdate = computed(() => {
  if (props.data?.personal?.birthdate) {
    const date = new Date(props.data.personal.birthdate)
    const formatter = new Intl.DateTimeFormat('de-CH', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

    return formatter.format(date)
  }
  return undefined
})

const meansOfContact = computed(() => {
  const v = props.data?.contact?.contact?.meansOfContact || 'mail'
  const means = v === 'mail' ? 'E-Mail' : 'Telefon'
  return 'Kontaktaufnahme via ' + means
})

const date = computed(() => {
  const v = props.data?.appointment?.date
  if (!v) {
    return
  }

  const dateObject = new Date(v)
  return formatDate(dateObject, true)
})

const time = computed(() => {
  return props.data?.appointment?.time
})

const agency = computed(() => {
  const id = props.data?.appointment?.agency
  if (!id) {
    return
  }

  return props.agencies.find((v) => v.value === id)?.label
})
</script>

<style lang="postcss">
.order-summary-table {
  th,
  td {
    @apply align-top py-16;
  }

  tr {
    @apply border-b border-b-gray-300;
  }
}
</style>
